export default function Header(props) {
    return (
        <div className="container main-header pt-lg-5 pt-4 pb-2" animate="down">
            <h1 animate="down">{props.title}</h1>
        </div>
    )
}